// assets/facets-canvas.js
class FacetFiltersForm extends HTMLElement {
  connectedCallback() {
    if (this.__mounted) return;
    this.__mounted = true;

    // tránh browser tự nhảy scroll khi replaceState
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";

    this.onChange = this.onChange.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onDocClick = this.onDocClick.bind(this);

    // click applied / clear-all (global)
    document.addEventListener("click", this.onDocClick, { passive: false });

    // bind form (vì DOM sẽ bị replace)
    this.bindForm();

    // init modules
    this.initPriceRange();
    this.initSortSelect(); // ✅ sort ngoài form vẫn ăn ngay từ đầu
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onDocClick);
    this.unbindForm();

    if (this._sortObserver) {
      this._sortObserver.disconnect();
      this._sortObserver = null;
    }

    this.__mounted = false;
  }

  get sectionId() {
    return this.dataset.sectionId || this.getAttribute("data-section-id");
  }

  /* ===================== HELPERS ===================== */

  // ✅ giữ các param "quan trọng" cho search page để không bị trống
  // - q (search terms)
  // - type (product,page,article,collection...)
  // - options[prefix] (Shopify search behavior)
  // - sort_by (select nằm ngoài form)
  _keepSearchParams(params, baseUrl) {
    const cur = baseUrl instanceof URL ? baseUrl : new URL(window.location.href);

    const KEYS = ["q", "type", "options[prefix]", "sort_by"];

    KEYS.forEach((k) => {
      const v = cur.searchParams.get(k);
      if (v && !params.get(k)) params.set(k, v);
    });

    return params;
  }

  // ✅ merge q/type/options[prefix]/sort_by từ URL hiện tại vào URL remove/clear
  _mergeKeepIntoUrl(urlObj) {
    const url = urlObj instanceof URL ? urlObj : new URL(String(urlObj), location.origin);
    const cur = new URL(window.location.href);

    const KEYS = ["q", "type", "options[prefix]", "sort_by"];

    KEYS.forEach((k) => {
      const v = cur.searchParams.get(k);
      // chỉ set nếu link remove/clear không có key đó
      if (v && !url.searchParams.get(k)) url.searchParams.set(k, v);
    });

    return url;
  }

  /* ===================== BIND / REBIND FORM ===================== */
  bindForm() {
    this.unbindForm();

    this.form = this.querySelector("form");
    if (!this.form) return;

    this.form.addEventListener("change", this.onChange);
    // toggle-off availability (input có data-remove-url)
    this.form.addEventListener("mousedown", this.onMouseDown);
  }

  unbindForm() {
    if (!this.form) return;
    this.form.removeEventListener("change", this.onChange);
    this.form.removeEventListener("mousedown", this.onMouseDown);
    this.form = null;
  }

  /* ===================== SORT SELECT (OUTSIDE) ===================== */
  initSortSelect() {
    if (this._sortInited) return;
    this._sortInited = true;

    const tryBind = () => {
      const sel = document.querySelector("[data-sort-select]");
      if (!sel) return false;

      if (sel.__tfBound) return true;
      sel.__tfBound = true;

      sel.addEventListener("change", () => {
        const val = sel.value || "";
        const url = new URL(window.location.href);

        if (val) url.searchParams.set("sort_by", val);
        else url.searchParams.delete("sort_by");

        this.renderFromUrl(url);
      });

      return true;
    };

    // bind ngay nếu có
    if (tryBind()) return;

    // chưa có => đợi DOM render xong
    const obs = new MutationObserver(() => {
      if (tryBind()) {
        obs.disconnect();
        this._sortObserver = null;
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
    this._sortObserver = obs;
  }

  syncSortSelectFromUrl(urlObj) {
    const sel = document.querySelector("[data-sort-select]");
    if (!sel) return;

    const url = urlObj instanceof URL ? urlObj : new URL(String(urlObj), window.location.origin);
    const sort = url.searchParams.get("sort_by");

    if (!sort) return;

    Array.from(sel.options).forEach((o) => {
      o.selected = o.value === sort;
    });
  }

  /* ===================== SCROLL ===================== */
  getProductGridEl() {
    return (
      document.querySelector("[data-product-grid]") ||
      document.querySelector("[data-grid-product]") ||
      null
    );
  }

  getToolbar() {
    return (
      document.querySelector(".tf-toolbar") ||
      document.querySelector("[data-toolbar]") ||
      null
    );
  }

  getHeaderOffset() {
    const header = document.querySelector(".section-header");
    return header ? header.getBoundingClientRect().height : 0;
  }

  getToobarOffset() {
    const toolbar = document.querySelector(".tf-toolbar");
    return toolbar ? toolbar.getBoundingClientRect().height : 0;
  }

  

  scrollToProductGrid() {
    const grid = this.getToolbar();
    if (!grid) return;

    const top =
      window.scrollY +
      grid.getBoundingClientRect().top -
      this.getHeaderOffset() -  this.getToobarOffset() ;
    
      console.log(top);

    window.scrollTo({ top, behavior: "smooth" });
  }

  /* ===================== PRICE RANGE ===================== */
  initPriceRange() {
    const root = this.querySelector("[data-price-range]");
    if (!root) return;

    const minSlider = root.querySelector("[data-price-slider-min]");
    const maxSlider = root.querySelector("[data-price-slider-max]");
    const minInput  = root.querySelector("[data-price-min]");
    const maxInput  = root.querySelector("[data-price-max]");
    const minHidden = root.querySelector("[data-price-min-hidden]");
    const maxHidden = root.querySelector("[data-price-max-hidden]");
    const rangeBar  = root.querySelector("[data-price-range-bar]");
    const thumbMin  = root.querySelector("[data-price-thumb-min]");
    const thumbMax  = root.querySelector("[data-price-thumb-max]");

    if (!minSlider || !maxSlider || !minInput || !maxInput || !minHidden || !maxHidden) return;

    const factor = parseInt(root.dataset.priceFactor || "100", 10) || 100; // 100 or 1
    const maxRaw = parseInt(root.dataset.priceMaxRaw || maxSlider.max || "0", 10) || 0;

    const clampRaw = (v) => Math.max(0, Math.min(maxRaw, v));
    const rawToDisplay = (raw) => raw / factor;

    // allow empty while typing
    const parseDisplay = (val) => {
      const s = String(val ?? "").trim();
      if (s === "") return null;
      const n = Number(s);
      return Number.isFinite(n) ? n : null;
    };

    const displayToRaw = (displayNumber) => Math.round(displayNumber * factor);
    const decimals = factor === 1 ? 0 : 2;
    const fmt = (n) => Number(n).toFixed(decimals);

    const paint = (aRaw, bRaw) => {
      const left = maxRaw ? (aRaw / maxRaw) * 100 : 0;
      const right = maxRaw ? (bRaw / maxRaw) * 100 : 0;

      if (rangeBar) {
        rangeBar.style.left = `${left}%`;
        rangeBar.style.width = `${Math.max(0, right - left)}%`;
      }
      if (thumbMin) thumbMin.style.left = `${left}%`;
      if (thumbMax) thumbMax.style.left = `${right}%`;
    };

    // state (raw)
    let aRaw = parseInt(minSlider.value || "0", 10) || 0;
    let bRaw = parseInt(maxSlider.value || String(maxRaw), 10) || maxRaw;

    const setHidden = () => {
      // hidden submit values are in DISPLAY units (keep your current behavior)
      minHidden.value = aRaw === 0 ? "" : fmt(rawToDisplay(aRaw));
      maxHidden.value = bRaw === maxRaw ? "" : fmt(rawToDisplay(bRaw));
    };

    const syncSliders = () => {
      minSlider.value = String(aRaw);
      maxSlider.value = String(bRaw);
      paint(aRaw, bRaw);
      setHidden();
    };

    const commitInputs = () => {
      minInput.value = aRaw === 0 ? "" : fmt(rawToDisplay(aRaw));
      maxInput.value = bRaw === maxRaw ? "" : fmt(rawToDisplay(bRaw));
    };

    const submitDebounced = (ms = 300) => {
      clearTimeout(this._priceT);
      this._priceT = setTimeout(() => this.submitForm(), ms);
    };

    // bind once per root instance
    if (!root.__priceBound) {
      root.__priceBound = true;

      // slider -> submit
      const onSliderInput = () => {
        aRaw = clampRaw(parseInt(minSlider.value || "0", 10) || 0);
        bRaw = clampRaw(parseInt(maxSlider.value || "0", 10) || 0);
        if (aRaw > bRaw) [aRaw, bRaw] = [bRaw, aRaw];

        syncSliders();
        commitInputs();
        submitDebounced(300);
      };

      minSlider.addEventListener("input", onSliderInput);
      maxSlider.addEventListener("input", onSliderInput);

      // inputs typing: sync but NO submit, NO overwrite while empty
      minInput.addEventListener("input", () => {
        const d = parseDisplay(minInput.value);
        if (d === null) {
          aRaw = 0;
          if (aRaw > bRaw) bRaw = aRaw;
          syncSliders();
          return;
        }
        aRaw = clampRaw(displayToRaw(d));
        if (aRaw > bRaw) bRaw = aRaw;
        syncSliders();
      });

      maxInput.addEventListener("input", () => {
        const d = parseDisplay(maxInput.value);
        if (d === null) {
          bRaw = maxRaw;
          if (aRaw > bRaw) aRaw = bRaw;
          syncSliders();
          return;
        }
        bRaw = clampRaw(displayToRaw(d));
        if (aRaw > bRaw) aRaw = bRaw;
        syncSliders();
      });

      // blur/enter => submit
      const commitSubmit = () => {
        commitInputs();
        submitDebounced(0);
      };

      minInput.addEventListener("blur", commitSubmit);
      maxInput.addEventListener("blur", commitSubmit);

      const onKeyDown = (e) => {
        if (e.key !== "Enter") return;
        e.preventDefault();
        e.target.blur();
      };
      minInput.addEventListener("keydown", onKeyDown);
      maxInput.addEventListener("keydown", onKeyDown);
    }

    aRaw = clampRaw(aRaw);
    bRaw = clampRaw(bRaw);
    if (aRaw > bRaw) [aRaw, bRaw] = [bRaw, aRaw];

    syncSliders();
    commitInputs();
  }

  /* ===================== EVENTS ===================== */

  // click lại availability đang active => remove via url_to_remove
  onMouseDown(e) {
    const input = e.target.closest('input[data-active="true"][data-remove-url]');
    if (!input) return;

    e.preventDefault();
    const url = this._mergeKeepIntoUrl(new URL(input.dataset.removeUrl, location.origin));
    this.renderFromUrl(url);
  }

  onDocClick(e) {
    const target = e.target.closest(
      "[data-clear-all], #applied-filters .remove-tag[data-remove-url], #applied-filters a"
    );

    if (!target) return;

    e.preventDefault();
    e.stopPropagation();

    let url;

    if (target.matches("[data-clear-all]")) {
      url = new URL(target.href, location.origin);
    } else if (target.matches("[data-remove-url]")) {
      url = new URL(target.dataset.removeUrl, location.origin);
    } else {
      url = new URL(target.href, location.origin);
    }

    url = this._mergeKeepIntoUrl(url);

    const drawer = target.closest(".canvas-filter, .offcanvas, .sidebar-filter, [data-filter-drawer]");
    const drawerScrollTop = drawer ? drawer.scrollTop : 0;
    const pageScrollTop = window.scrollY;

    this.renderFromUrl(url);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo(0, pageScrollTop);

        if (drawer) {
          drawer.scrollTop = drawerScrollTop;
        }
      });
    });
  }
  onChange() {
    clearTimeout(this._t);
    this._t = setTimeout(() => this.submitForm(), 150);
  }

  submitForm() {
    if (!this.form) return;

    const params = new URLSearchParams(new FormData(this.form));

    // ✅ giữ q/type/options[prefix]/sort_by để search không bị trống
    this._keepSearchParams(params, new URL(window.location.href));

    const url = new URL(window.location.href);
    url.search = params.toString();
    this.renderFromUrl(url);
  }

  /* ===================== AJAX RENDER ===================== */
  renderFromUrl(urlObj) {
    const sectionId = this.sectionId;
    if (!sectionId) return (window.location.href = urlObj.toString());

    const fetchUrl = new URL(urlObj.toString());
    fetchUrl.searchParams.set("section_id", sectionId);

    document.documentElement.classList.add("facets-loading");

    fetch(fetchUrl.toString(), { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newSec = doc.querySelector(`[data-section-id="${CSS.escape(sectionId)}"]`);
        const curSec = document.querySelector(`[data-section-id="${CSS.escape(sectionId)}"]`);

        if (!newSec || !curSec) return (window.location.href = urlObj.toString());

        

        const wasFilterOpen = document.documentElement.classList.contains("tf-filter-open");

        curSec.innerHTML = newSec.innerHTML;

        if (wasFilterOpen) {
          const sidebar = document.querySelector(".sidebar-filter");
          const overlay = document.querySelector("[data-filter-overlay]");

          if (sidebar) sidebar.classList.add("is-open");
          if (overlay) overlay.hidden = false;

          document.documentElement.classList.add("tf-filter-open");
        }
        
        history.replaceState({}, "", urlObj.toString());

        this.syncResultCount(newSec);

        // keep sort select synced
        this.syncSortSelectFromUrl(urlObj);

        requestAnimationFrame(() => {
          // ✅ form node replaced => rebind properly
          this.bindForm();
          this.initPriceRange();

          document.dispatchEvent(
            new CustomEvent("facets:updated", {
              detail: { sectionId: sectionId },
            })
          );

          requestAnimationFrame(() => this.scrollToProductGrid());
        });

        // optional: re-init other components after ajax
        window.InfiniteSlide?.mountAll?.(document);
      })
      .finally(() => document.documentElement.classList.remove("facets-loading"));
  }

  syncResultCount(newSection) {
    const newCount = newSection.querySelector("[data-result-count]");
    const curCount = document.querySelector("[data-result-count]");
    if (!newCount || !curCount) return;
    curCount.innerHTML = newCount.innerHTML;
  }
}

customElements.define("facet-filters-form", FacetFiltersForm);
